document.addEventListener('DOMContentLoaded', function () {
  const page = document.querySelector('.product-page');
  if (!page) return;

  const mainImages = page.querySelectorAll('.product-main-image');
  const total = mainImages.length;
  let currentIndex = 0;

  function selectImage(idx) {
    currentIndex = ((idx % total) + total) % total;
    page.querySelectorAll('.product-thumb').forEach((t, i) => t.classList.toggle('active', i === currentIndex));
    mainImages.forEach((img, i) => img.classList.toggle('active', i === currentIndex));
    page.querySelectorAll('.product-img-dot').forEach((d, i) => d.classList.toggle('active', i === currentIndex));
  }

  page.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => selectImage(Number(thumb.dataset.thumbIndex)));
  });
  page.querySelectorAll('.product-img-dot').forEach((dot) => {
    dot.addEventListener('click', () => selectImage(Number(dot.dataset.dotIndex)));
  });

  const prevBtn = page.querySelector('[data-gallery-prev]');
  const nextBtn = page.querySelector('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', () => selectImage(currentIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => selectImage(currentIndex + 1));
});